import {AuthLifecycle, AuthStrategy} from './auth-strategy.types';
import {KeycloakAuthStrategy} from './keycloak-auth.strategy';
import {SessionTokenAuthStrategy} from './session-token-auth.strategy';

export class AuthStrategyFactory {
  public static create(lifecycle: AuthLifecycle): AuthStrategy {
    return AuthStrategyFactory.isSessionTokenMode()
      ? new SessionTokenAuthStrategy(lifecycle)
      : new KeycloakAuthStrategy(lifecycle);
  }

  private static isSessionTokenMode(): boolean {
    return process.env.REACT_APP_E2E_AUTH === '1';
  }
}
